<template>
    <!--定点投放--投放管理--绑定标签 对话框  绑定标签功能已去掉 -->

    <div>
        <el-dialog title="绑定标签" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="80%" destroy-on-close>
            <div style="font-weight: 700; font-size: 20px; text-align: center; margin-bottom: 20px">渠道码:{{ labelName }}</div>
            <div style="font-size: 16px; margin-bottom: 20px; color: red">
                注：请勾选该渠道码要绑定的标签，可多选，勾选后点击“确定”按钮进行绑定
            </div>
            <el-table
                :data="tableData"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="标签名称" prop="name" min-width="130"> </el-table-column>

                <el-table-column label="标签编码" prop="promotion_label_code" min-width="100"> </el-table-column>

                <el-table-column label="城市" prop="city.name" min-width="180"> </el-table-column>

                <el-table-column label="创建时间" prop="time.YmdHis"> </el-table-column>
            </el-table>

            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center;margin-top:20px">
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    :data="submit_data"
                    :rules="submit_rules"
                    :url="submit_url"
                    :JSON_Boolean="false"
                  

                ></submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.labelName = _this.data.name;

           
            _this.submit_data.promotion_qr_code = _this.data.promotion_qr_code;
            _this.detail_data.promotion_qr_code = _this.data.promotion_qr_code;
             _this.getBindPromotionQRLabelDetail().then(() => {
                _this.promotionLabelLists();
            });

        }
    },

    data() {
        return {
            show: false,
    
            //全部勾选
            // tableAllSelected: [],

            //当前页勾选
            // tableCurrentSelected: [],
          
            submit_url: '/promotion/bindPromotionQRLabel',
            // 表单数据
            labelName: '',
            result_data: {},
            submit_data: {
                promotion_qr_code: '',
                promotion_label_code_array: []
            },
            detail_data: {
                promotion_qr_code: ''
            },
            search_data: {
                // page: 1,
                // limit: 10,
                name: ''
            },

            submit_rules: {
                promotion_label_code_array: {
                    placeholder: '标签',
                    rules: {
                        required: true,
                        message: '标签错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            },

            // 存放表格数据
            tableData: [],

        };
    },
    created() {
        _this = this;
    },

    methods: {
        // toJSON(){
        //     // 存在一种情况，就是我们在当前页面勾选后不去走分页了，那么就需要把当前勾选与this.submit_data.promotion_label_code_array进行数组合并
        //     this.submit_data.promotion_label_code_array = [... new Set( this.submit_data.promotion_label_code_array.concat(_this.tableCurrentSelected))];


        //     console.log(this.submit_data.promotion_label_code_array,'-=-----');
        // },
        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
        closeDialog() {
            _this.show = false;

            _this.labelName = '';

            _this.submit_data = {
                promotion_qr_code: '',
                promotion_label_code_array: []
            };

            _this.tableAllSelected=[];
            _this.tableCurrentSelected=[];
            _this.detail_data = {
                promotion_qr_code: ''
            };
            _this.search_data = {
                // page: 1,
                // limit: 10,
                name: ''
            };
        },
        // 全选或多选
        handleSelectionChange(val) {
            // console.log(this.$refs.multipleTable, 'this.$refs');
            console.log(val,'val');
            
            var datalist = [];
            for (var i in val) {
              
                    datalist.push(val[i].promotion_label_code);           
            }

            //把当前勾选赋值给tableCurrentSelected
            // console.log(_this.tableCurrentSelected,' _this.tableCurrentSelected1');
            // _this.tableCurrentSelected = datalist;
            // console.log(_this.tableCurrentSelected,' _this.tableCurrentSelected2');
       
               _this.submit_data.promotion_label_code_array = datalist;

         

       

    
        }, 
        searchPromotionLabelLists() {
            // _this.search_data.page = 1;
            _this.promotionLabelLists();
        },

        promotionLabelLists() {
            _this
                .$post('/promotion/promotionLabelLists', _this.search_data)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    //遍历列表接口和详情接口返回值，如果列表接口返回的行数据promotion_label_code的值==详情接口返回数据中的编码，则勾选
                    //使用 $nextTick，目的是为了可以获取到更新后的DOM

                    // console.log(_this.submit_data.promotion_label_code_array, '=========');

                    for (let i = 0; i < this.tableData.length; i++) {
                        for (let j = 0; j < this.submit_data.promotion_label_code_array.length; j++) {
                            if (this.tableData[i].promotion_label_code === this.submit_data.promotion_label_code_array[j]) {
                                this.$nextTick(() => {
                                    this.$refs['multipleTable'].toggleRowSelection(this.tableData[i], true);
                                });
                            }
                        }
                    }
                })
                .catch((err) => {});
        },
        //先调详情接口，把返回值赋值给_this.submit_data.promotion_label_code_array，这样防止详情接口没赋值就走列表接口
        getBindPromotionQRLabelDetail() {
            return new Promise((resolve, reject) => {
                _this
                    .$post('/promotion/getBindPromotionQRLabelDetail', _this.detail_data)
                    .then((res) => {
                        _this.submit_data.promotion_label_code_array = res.data;
                        resolve();
                    })
                    .catch((err) => {});
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.promotionLabelLists();
        },
        //页码变化
        // handleCurrentChange(val) {  
        //     _this.search_data.page = val;

        //     var allArray = [];
            
        //     // 分页会导致前一个页面勾选的值被取消,为了记住分页时前一页勾选的数据，把当前页勾选的数据放到全部勾选数组中进行保存
        //     // 把当前勾选的值加入到tableAllSelected全部勾选数组中需要用.concat方法进行数组合并
        //     if(_this.tableCurrentSelected.length!=0){
           
        //         allArray = _this.tableAllSelected.concat(_this.tableCurrentSelected);
        //     }


        //     // 为了保证每次分页的时候，都显示接口返回的已勾选的数据，分页的时候需要先调取详情接口，把勾选数据赋值给this.submit_data.promotion_label_code_array，然后再去调用列表接口
        //     //调列表接口的时候，遍历列表数据中的编码值去跟详情接口返回的编码值进行比对，如果对应上了，则勾选上（this.$refs['multipleTable'].toggleRowSelection(this.tableData[i], true);）
           
        //     _this.tableAllSelected = [... new Set(allArray)]; //数组去重
     
   
        //     //下面这步是为了把分页前手动勾选的值与详情接口返回值一同勾选，也就是记住了分页前手动勾选的值
        //     this.submit_data.promotion_label_code_array = [... new Set( this.submit_data.promotion_label_code_array.concat(_this.tableAllSelected))];
         
        //     _this.promotionLabelLists();
           
        // },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
